import { api, Tags } from "@state/apiSlice";

import { EditIpBody } from "@hz/stealthy-gmc-cloaker-common/api-types/whitelist";
import { GetIPsResponse } from "@hz/stealthy-gmc-cloaker-common/api-types/whitelist";

const whitelistRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getWhitelistedIps: build.query<GetIPsResponse, {}>({
      query: () => ({
        url: "/whitelist",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: [Tags.IPs],
    }),

    addIP: build.mutation<{ success: boolean; message: string }, { ipAddress: string; tag?: string }>({
      query: (data) => ({
        url: "/whitelist",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          ipAddress: data.ipAddress,
          tag: data?.tag,
        },
        method: "POST",
      }),
      invalidatesTags: [Tags.IPs],
    }),

    syncMyIP: build.mutation<{ success: boolean; message: string }, {}>({
      query: () => ({
        url: "/whitelist/me",
      
        method: "POST",
      }),
      invalidatesTags: [Tags.IPs],
    }),

    editIPAddress: build.mutation<{ success: boolean; ip: string }, EditIpBody & { ipId: string }>({
      query: ({ ipAddress, tag, ipId }) => ({
        url: `/whitelist/${ipId}`,
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          ipAddress,
          tag,
        },
        method: "PATCH",
      }),
      invalidatesTags: [Tags.IPs],
    }),

    deleteIPAddress: build.mutation<{ success: boolean}, { ipId: string }>({
      query: ({ipId}) => ({
        url: `/whitelist/${ipId}`,
        method: "DELETE",
      }),
      invalidatesTags: [Tags.IPs],
    }),
  }),
});

export default whitelistRequestsSlice;
